import classNames from 'classnames';
import { FunctionComponent } from 'react';
import styles from './styles.module.scss';

export type MeterProps = {
    className?: string;
    barClassName?: string;
    ariaLabel?: string;
    value: number;
};

const Meter: FunctionComponent<MeterProps> = ({ className, barClassName, value, ariaLabel }) => {
    return (
        <div className={classNames(styles.meter, className)} aria-label={ariaLabel}>
            <div
                className={classNames(styles.bar, barClassName)}
                style={{ width: `${value}%` }}
            ></div>
        </div>
    );
};

export default Meter;
